import { render } from "./MenuScreen.vue?vue&type=template&id=133f5a72"
import script from "./MenuScreen.vue?vue&type=script&lang=js"
export * from "./MenuScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__